// Delivery (driver) mode — a per-device preference, not session state. When on,
// the app launches into the driver surface (/driver) instead of the POS, and the
// driver gets a focused shell. Stored in localStorage so it survives reloads and
// is readable synchronously from route `beforeLoad` (before React/stores mount).
//
// There's no driver *role* — this is a manual toggle (entered from the Functions
// tab, exited from the driver Account tab). See docs/fulfillment-roadmap.md M4.

const KEY = 'waio_delivery_mode'

export function getDeliveryMode(): boolean {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function setDeliveryMode(on: boolean): void {
  try {
    if (on) localStorage.setItem(KEY, '1')
    else localStorage.removeItem(KEY)
  } catch {
    /* private mode / storage disabled — mode just won't persist */
  }
}
